import React from "react";
import "./PrivacyPolicy.scss";
import { Text } from "components/core/Typography";
import PropTypes from "prop-types";

const Heading = ({ content, color = "black" }) => (
	<>
		{content && (
			<Text
				weight="semiBold"
				size="medium"
				color={color}
			>
				{content}
			</Text>
		)}
	</>
);

Heading.propTypes = {
	content: PropTypes.string,
	color: PropTypes.string
};

export default Heading;
